var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArShadesLibraryicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    zoomAndPan: "magnify",
    viewBox: "0 0 384 383.999986",
    height: 512,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ba908cb5f3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 96.148438 305.460938 L 374.960938 305.460938 L 374.960938 374.894531 L 96.148438 374.894531 Z M 96.148438 305.460938 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "433406b0f8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 109.648438 305.460938 L 361.238281 305.460938 C 368.691406 305.460938 374.738281 311.507812 374.738281 318.960938 L 374.738281 361.394531 C 374.738281 368.847656 368.691406 374.894531 361.238281 374.894531 L 109.648438 374.894531 C 102.191406 374.894531 96.148438 368.847656 96.148438 361.394531 L 96.148438 318.960938 C 96.148438 311.507812 102.191406 305.460938 109.648438 305.460938 Z M 109.648438 305.460938 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9d6cd67aee"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.261719 9 L 78.914062 9 L 78.914062 374.886719 L 9.261719 374.886719 Z M 9.261719 9 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b2e905e7ea"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.261719 361.386719 L 9.261719 22.597656 C 9.261719 19.019531 10.683594 15.585938 13.214844 13.054688 C 15.746094 10.523438 19.179688 9.097656 22.761719 9.097656 L 65.414062 9.097656 C 68.992188 9.097656 72.425781 10.523438 74.957031 13.054688 C 77.488281 15.585938 78.914062 19.019531 78.914062 22.597656 L 78.914062 361.386719 C 78.914062 364.96875 77.488281 368.402344 74.957031 370.933594 C 72.425781 373.464844 68.992188 374.886719 65.414062 374.886719 L 22.761719 374.886719 C 19.179688 374.886719 15.746094 373.464844 13.214844 370.933594 C 10.683594 368.402344 9.261719 364.96875 9.261719 361.386719 Z M 9.261719 361.386719 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "3164525ec0"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#ba908cb5f3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#433406b0f8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#241f45",
      fillOpacity: 1
    },
    d: "M 96.148438 305.460938 L 374.691406 305.460938 L 374.691406 374.894531 L 96.148438 374.894531 Z M 96.148438 305.460938 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#9d6cd67aee)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#b2e905e7ea)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#241f45",
      fillOpacity: 1
    },
    d: "M 9.261719 374.886719 L 9.261719 9.21875 L 78.914062 9.21875 L 78.914062 374.886719 Z M 9.261719 374.886719 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArShadesLibraryicon);
export default __webpack_public_path__ + "static/media/ARShades Library icon.951d10f3879acbd9b126e3826080fd89.svg";
export { ForwardRef as ReactComponent };